// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as ToolsHeadlineAnalyzerRouteImport } from './routes/tools.headline-analyzer'
import { Route as ToolsKeywordExplorerRouteImport } from './routes/tools.keyword-explorer'
import { Route as ToolsWebsiteAuditRouteImport } from './routes/tools.website-audit'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const ToolsHeadlineAnalyzerRoute = ToolsHeadlineAnalyzerRouteImport.update({
            id: '/tools/headline-analyzer',path: '/tools/headline-analyzer',getParentRoute: () => rootRouteImport
          })
const ToolsKeywordExplorerRoute = ToolsKeywordExplorerRouteImport.update({
            id: '/tools/keyword-explorer',path: '/tools/keyword-explorer',getParentRoute: () => rootRouteImport
          })
const ToolsWebsiteAuditRoute = ToolsWebsiteAuditRouteImport.update({
            id: '/tools/website-audit',path: '/tools/website-audit',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })





const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,AuthRoute: AuthRoute,CareersRoute: CareersRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,ServicesRoute: ServicesRouteWithChildren,TermsRoute: TermsRoute,BlogSlugRoute: BlogSlugRoute,ToolsHeadlineAnalyzerRoute: ToolsHeadlineAnalyzerRoute,ToolsKeywordExplorerRoute: ToolsKeywordExplorerRoute,ToolsWebsiteAuditRoute: ToolsWebsiteAuditRoute,BlogIndexRoute: BlogIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)